import React, { useState, useEffect } from "react";
import myLogo from "./assets/orn1.webp"; 
import {
  collection,
  getDocs,
  query,
  where,
  limit
} from "firebase/firestore";
import Spinner from "./Spinner"; 
import './Login.css';
import { auth } from "../firebase";
import { signInAnonymously } from "firebase/auth";
import { db } from "../firebase";

// Cache berlaku selama 7 hari (dalam ms)
const CACHE_EXPIRATION_MS = 1000 * 60 * 60 * 24 * 7;

const Login = ({ onLogin }) => {
  const [nama, setNama] = useState("");
  const [pin, setPin] = useState("");
  const [showPin, setShowPin] = useState(false); // <-- new state
  const [tahun, setTahun] = useState(new Date().getFullYear().toString());
  const [error, setError] = useState("");
  const [namaOptions, setNamaOptions] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    const cached = localStorage.getItem("namaOptions");
    const cachedTime = localStorage.getItem("namaOptionsTime");
    const now = Date.now();
    const isExpired = !cachedTime || now - parseInt(cachedTime) > CACHE_EXPIRATION_MS;

    if (cached && !isExpired) {
      setNamaOptions(JSON.parse(cached));
    } else {
      const fetchPegawai = async () => {
        try {
          const pegawaiSnapshot = await getDocs(collection(db, "pegawai"));
          const pegawaiList = pegawaiSnapshot.docs.map((doc) => doc.data().nama);
          pegawaiList.sort(); 
          setNamaOptions(pegawaiList);
          localStorage.setItem("namaOptions", JSON.stringify(pegawaiList));
          localStorage.setItem("namaOptionsTime", now.toString());
        } catch (err) {
          console.error("Gagal mengambil data pegawai:", err);
        }
      };
      fetchPegawai();
    }
  }, []);

const handleLogin = async (e) => {
  e.preventDefault();
  setError("");
  setLoading(true);

  try {
    const q = query(
      collection(db, "pegawai"),
      where("nama", "==", nama),
      where("pin", "==", pin),
      limit(1)
    );
    const snapshot = await getDocs(q);

    if (snapshot.empty) {
      setError("Nama atau PIN salah!");
      setLoading(false);
      return;
    }

    const credential = await signInAnonymously(auth);
    const uid = credential.user.uid;

    const rawData = snapshot.docs[0].data();
    const { pin: _, ...data } = rawData;
    const userData = { ...data, uid };

    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("tahun", tahun);

    onLogin(userData);
  } catch (err) {
    setError("Terjadi kesalahan saat login.");
    console.error(err);
  } finally {
    setLoading(false);
  }
};


  
  return (
    <div className="login-wrapper">
      <div className="ornamentpic">
      <div className="loginLandingPage">
        <img src={myLogo} alt="Logo" className="imageOrn1"/>
      </div>
      </div>
      <div className="login-container">
        <div class="blur-background"></div>
        <div class="login-content">
        <h2>Login</h2>
        <form onSubmit={handleLogin}>
          <select
            value={nama}
            onChange={(e) => setNama(e.target.value)}
            required
            className="default-select"
          >
            <option value="">Nama</option>
            {namaOptions.map((n, i) => (
              <option key={i} value={n}>
                {n}
              </option>
            ))}
          </select>

          {/* password input with eye toggle */}
          <div className="password-wrapper">
            <input
              type={showPin ? "text" : "password"}
              placeholder="Password"
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              required
              aria-label="PIN"
              className="pin-input"
            />
            <button
              type="button"
              className="toggle-pin-btn"
              onClick={() => setShowPin((s) => !s)}
              aria-pressed={showPin}
              aria-label={showPin ? "Sembunyikan PIN" : "Tampilkan PIN"}
            >
              {showPin ? (
                // eye-off icon (you can replace with any SVG/icon)
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M3 3l18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M10.58 10.58A3 3 0 0 1 13.42 13.42" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2.16 12.11C3.62 8.86 7.13 6 12 6c2.06 0 3.92.5 5.47 1.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M21.84 11.89C20.38 15.14 16.87 18 12 18c-2.06 0-3.92-.5-5.47-1.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              ) : (
                // eye icon
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </button>
          </div>

<select
  className="tahun-select"
  value={tahun}
  onChange={(e) => setTahun(e.target.value)}
  required
>
  <option value="">Pilih Tahun</option>
  {Array.from({ length: 6 }, (_, i) => {
    const year = 2023 + i;
    return (
      <option key={year} value={year}>
        {year}
      </option>
    );
  })}
</select>


          <button type="submit" className="primary-btn">
  <span>Masuk</span>
</button>


          {error && <p className="error-message">{error}</p>}
        </form>
        <div className="lastword"><p>GKN Manado <br></br>2025</p>
        </div>
        </div>
      </div>
      
      {loading && <Spinner fullscreen />}

    </div>
  );
};

export default Login;
